// 创建文件en.js
const en = {
    building_des: 'Building Profile',
    title: 'Canghai Campus Building Health Monitoring System',
    wind_direction: 'wind',
    wind_power: 'power',
    wind_speed: 'speed',
    mon: 'Monday',
    sat: 'Saturday',
    sun: 'Sunday',
    tues: 'Tuesday',
    wed: 'Wednesday',
    thus: 'Thursday',
    fri: 'Friday',
    detail_pr: 'Detail info',
    node_status: 'Node Status',
    total: 'Total',
    node_power: 'Node Power',
    time: 'Time-Domain Diagram',
    time_detail: 'detail',
    a_alarm: 'Acceleration Alarm',
    f_alarm: 'Frequency Alarm',
    type: 'Type',
    wall: 'Frame-Shear',
    visitors_flowrate: 'Visitors',
    people_hour: 'p/h',
    area: 'Area',
    class_room: 'Class Rooms',
    main_build: 'Tower (17F)',
    annex: 'Podium (7F)',
    meeting_room: 'Meeting rooms',
    elevator: 'Elevators',
    online: 'Online',
    offline: 'Offline',
    abnormal: 'Anomaly',
    anomaly: 'anomaly',
    status: 'status',
    tai: '',
    n_status: 'Status',
    soc: 'SOC',
    today_alarm: 'D-alarm',
    month_alarm: 'M-alarm',
    times: 'times',
    health: 'Healh status',
    day: 'D',
    month: 'M',
    year: 'Y',
    back: 'BACK',
    freq_chart: 'Frequency Chart',
    time_chart: 'Acceleration Chart',
    load: 'Loading',
    normal: 'normal'


}
export default en;



// WEBPACK FOOTER //
// ./src/lang/en.js